import React from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Chip,
  Stack,
} from "@mui/material";
import { EXPERIENCE, EDUCATION, SKILLS } from "../../utils/constants";

const Experience = () => {
  return (
    <Box id="experience" sx={{ py: 8 }}>
      <Typography
        variant="h2"
        sx={{
          mb: 1,
          background: "linear-gradient(135deg, #2563eb, #7c3aed)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        Experience, Education & Skills
      </Typography>

      <Typography color="text.secondary" sx={{ maxWidth: 760, mb: 4 }}>
        A practical background that combines software development, technical
        support, documentation, student training, and self-driven product
        building.
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} md={7}>
          <Stack spacing={3}>
            {EXPERIENCE.map((item) => (
              <Card key={item.title} sx={{ borderRadius: 4 }}>
                <CardContent sx={{ p: 3 }}>
                  <Stack
                    direction={{ xs: "column", sm: "row" }}
                    justifyContent="space-between"
                    spacing={1.5}
                    sx={{ mb: 1.5 }}
                  >
                    <Box>
                      <Typography variant="h5" sx={{ fontWeight: 700 }}>
                        {item.title}
                      </Typography>
                      <Typography color="primary.main" sx={{ fontWeight: 600 }}>
                        {item.company}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {item.type}
                      </Typography>
                    </Box>
                    <Chip label={item.period} color="primary" />
                  </Stack>

                  <Box
                    component="ul"
                    sx={{ pl: 2.5, color: "text.secondary", mb: 0 }}
                  >
                    {item.points.map((point) => (
                      <Typography
                        key={point}
                        component="li"
                        variant="body2"
                        sx={{ mb: 0.9, lineHeight: 1.8 }}
                      >
                        {point}
                      </Typography>
                    ))}
                  </Box>
                </CardContent>
              </Card>
            ))}
          </Stack>
        </Grid>

        <Grid item xs={12} md={5}>
          <Stack spacing={3}>
            <Card sx={{ borderRadius: 4 }}>
              <CardContent sx={{ p: 3 }}>
                <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
                  Education
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                  {EDUCATION.degree}
                </Typography>
                <Typography color="primary.main" sx={{ fontWeight: 600 }}>
                  {EDUCATION.school}
                </Typography>
                <Typography color="text.secondary" sx={{ mt: 1 }}>
                  {EDUCATION.year} · {EDUCATION.grade}
                </Typography>

                <Typography sx={{ mt: 2, mb: 1.2, fontWeight: 600 }}>
                  Relevant Coursework
                </Typography>
                <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                  {EDUCATION.coursework.map((item) => (
                    <Chip key={item} label={item} />
                  ))}
                </Stack>
              </CardContent>
            </Card>

            <Card sx={{ borderRadius: 4 }}>
              <CardContent sx={{ p: 3 }}>
                <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
                  Technical Skills
                </Typography>

                <Typography sx={{ fontWeight: 700, mb: 1 }}>
                  Proficient
                </Typography>
                <Stack
                  direction="row"
                  spacing={1}
                  flexWrap="wrap"
                  useFlexGap
                  sx={{ mb: 2.5 }}
                >
                  {SKILLS.proficient.map((item) => (
                    <Chip key={item} label={item} size="small" />
                  ))}
                </Stack>

                <Typography sx={{ fontWeight: 700, mb: 1 }}>
                  Exploring / Developing
                </Typography>
                <Stack
                  direction="row"
                  spacing={1}
                  flexWrap="wrap"
                  useFlexGap
                  sx={{ mb: 2.5 }}
                >
                  {SKILLS.exploring.map((item) => (
                    <Chip
                      key={item}
                      label={item}
                      size="small"
                      variant="outlined"
                    />
                  ))}
                </Stack>

                <Typography sx={{ fontWeight: 700, mb: 1 }}>
                  Tools & Concepts
                </Typography>
                <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                  {SKILLS.tools.map((item) => (
                    <Chip key={item} label={item} size="small" />
                  ))}
                </Stack>
              </CardContent>
            </Card>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Experience;
